<ng-container *ngIf="!model.isPlanning">
  <q-affiche-week *ngIf="model.agendaMode === 'WEEK'"
                     [refreshData]="refreshData"
                     (refreshDataChange)="SetRefreshData($event)"
                     (loading)="EmitLoading($event)"
                     [model]="model"
                     (modelChange)="ModelChange($event)"
                     (openEvent)="OpenEvent($event)"
                     (newEvent)="OpenModal($event, content, 0)"></q-affiche-week>
  <q-affiche-month *ngIf="model.agendaMode === 'MONTH'" [model]="model"
                      (modelChange)="ModelChange($event)"
                      (loading)="EmitLoading($event)"
                      (openEvent)="OpenEvent($event)"
                      (newEvent)="OpenModal($event, content, 0)"></q-affiche-month>
</ng-container>
<ng-container *ngIf="model.isPlanning">

  <q-affiche-planning #Planning class="position-relative w-100"
                         (loading)="EmitLoading($event)"
                         [enlargeContainer]="enlargeContainer"
                         [model]="model"
                         [LoadInfos]="LoadInfos"
                         [refreshData]="refreshData"
                          (refreshDataChange)="SetRefreshData($event)"
                         (modelChange)="ModelChange($event)"
                         (openEvent)="OpenEvent($event)"
                         (newEvent)="OpenModal($event.date, content, $event.iCalendar)"></q-affiche-planning>
</ng-container>

<!-- #region Modal  -->
<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true" class="q-c-danger">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div *ngFor="let selagen of model.listCalendars[iCalendar].selectEvents; let i = index" class="row p-auto m-auto justify-content-center">

      <button *ngIf="selagen.isCreatable && selagen.isChecked && selagen.idRelation" class="button-code btn btn-block p-auto m-1" (click)="modal.dismiss(); NewEvent(selagen);" [style.color]="'white'" [style.background-color]="selagen.color" [style.border-color]="selagen.color">
        <i class="fas fa-plus"></i>
        {{selagen.label}}
      </button>
    </div>
  </div>
</ng-template>
